<template>
  <div class="navigation-container10">
    <div>
      <nav id="navigationMain" role="navigation" aria-label="Main navigation" class="nav-korpus">
        <div class="container10"><div class="container11"></div></div>
        <div class="container12"><div class="container13"></div></div>
        <div>
          <div class="nav-korpus__container">
            <router-link to="/">
              <div class="navigation-container21">
                <div>
                  <img alt="image" src="/logo_korpus-registered-200h.png" class="image1"/>
                </div>
              </div>
            </router-link>
            <div>
              <ul id="navMenu" role="list" class="nav-korpus__menu1">
                <li class="nav-korpus__menu-item">
                  <router-link to="/product">
                    <div class="navigation-container24">
                      <div class="container17">
                        <div class="container2">
                          <div class="nav-korpus__link"><span>{{$t('navigation.menu.product')}}</span></div>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </li>
                <li class="nav-korpus__menu-item">
                  <router-link to="/integrations">
                    <div class="navigation-container25">
                      <div class="container18">
                        <div class="container3">
                          <div class="nav-korpus__link"><span>{{$t('navigation.menu.integrations')}}</span></div>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </li>
                <li class="nav-korpus__menu-item">
                  <router-link to="/solutions">
                    <div class="navigation-container26">
                      <div class="container19">
                        <div class="container4">
                          <div class="nav-korpus__link"><span>{{$t('navigation.menu.solutions')}}</span></div>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </li>
                <li class="nav-korpus__menu-item">
                  <router-link to="/pricing">
                    <div class="navigation-container27">
                      <div class="container20">
                        <div class="container52">
                          <div class="nav-korpus__link"><span>{{$t('navigation.menu.pricing')}}</span></div>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </li>
                <li class="nav-korpus__menu-item">
                  <router-link to="/resellers">
                    <div class="navigation-container28">
                      <div class="container21">
                        <div class="container6">
                          <div class="nav-korpus__link"><span>{{$t('navigation.menu.resellers')}}</span></div>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </li>
                <li class="navigation-thq-nav-korpusmenu-item-elm6 nav-korpus__menu-item">
                  <router-link to="/customerstories">
                    <div class="navigation-container29">
                      <div class="container22">
                        <div class="container7">
                          <div class="nav-korpus__link"><span>{{$t('navigation.menu.customerStories')}}</span></div>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </li>
                <li class="nav-korpus__menu-item">
                  <router-link to="/about">
                    <div class="navigation-container30">
                      <div class="container23">
                        <div class="container8">
                          <div class="nav-korpus__link"><span>{{$t('navigation.menu.about')}}</span></div>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="nav-korpus__actions">
              <button id="themeToggle" type="button" aria-label="Toggle dark mode" aria-pressed="false" class="nav-korpus__theme-toggle">
                <span aria-hidden="true" class="navigation-thq-nav-korpustheme-icon1-elm">
                  <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                    <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle r="4" cx="12" cy="12"></circle>
                      <path d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32l1.41 1.41M2 12h2m16 0h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"></path>
                    </g>
                  </svg>
                </span>
                <span aria-hidden="true" class="navigation-thq-nav-korpustheme-icon2-elm">
                  <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                    <path d="M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </span>
              </button>
              <router-link to="/contactdemo">
                <div class="navigation-container31">
                  <div>
                    <div class="btn btn-primary nav-korpus__cta">
                      <span>{{$t('navigation.cta.bookDemo')}}</span>
                    </div>
                  </div>
                </div>
              </router-link>
              <button id="mobileMenuToggle" type="button" aria-label="Toggle navigation menu" aria-controls="navMenu" aria-expanded="false" class="nav-korpus__mobile-toggle">
                <span aria-hidden="true" class="navigation-thq-nav-korpusmobile-icon1-elm">
                  <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                    <path d="M4 5h16M4 12h16M4 19h16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </span>
                <span aria-hidden="true" class="navigation-thq-nav-korpusmobile-icon2-elm">
                  <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                    <path d="M18 6L6 18M6 6l12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </span>
              </button>
            </div>
            <!-- Language Selector -->
            <div class="language-selector" @click="toggleLanguageDropdown">
              <span class="current-language">{{ selectedLanguage }}</span>
              <span class="arrow" :class="{ open: showLanguageDropdown }"></span>

              <ul v-if="showLanguageDropdown" class="language-options">
                <li @click.stop="setLanguage('NL')">NL</li>
                <li @click.stop="setLanguage('FR')">FR</li>
                <li @click.stop="setLanguage('EN')">EN</li>
                <li @click.stop="setLanguage('DE')">DE</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="nav-korpus__mobile-cta">
          <router-link to="/contactdemo">
            <div>
              <div class="btn btn-primary"><span>{{$t('navigation.cta.planDemo')}}</span></div>
            </div>
          </router-link>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Navigation',
  props: {},
  data() {
    return {
      selectedLanguage: this.getCurrentLanguage(),
      showLanguageDropdown: false,
    }
  },
  methods: {
    toggleLanguageDropdown() {
      this.showLanguageDropdown = !this.showLanguageDropdown;
    },
    setLanguage(lang) {
      const locale = lang.toLowerCase();

      this.selectedLanguage = lang;
      this.showLanguageDropdown = false;
      this.$i18n.locale = locale;
      document.documentElement.lang = locale;

      try {
        localStorage.setItem('korpus-language', locale);
      } catch (error) {
        // Ignore storage errors; the active session language still changes.
      }
    },
    getCurrentLanguage() {
      return (this.$i18n?.locale || 'nl').toUpperCase();
    },
  },
  mounted() {
    this.selectedLanguage = this.getCurrentLanguage()
    document.documentElement.lang = this.$i18n.locale

    // Vue 3 migration/security: replace inline script injection with mounted logic.
    const cleanupHandlers = []
    const addListener = (target, event, handler, options) => {
      if (!target) {
        return
      }
      target.addEventListener(event, handler, options)
      cleanupHandlers.push(() => target.removeEventListener(event, handler))
    }

    const themeToggle = document.getElementById('themeToggle')
    const htmlElement = document.documentElement
    const colorVariables = [
      'color-primary',
      'color-secondary',
      'color-accent',
      'color-neutral',
      'color-surface',
      'color-on-surface',
      'color-on-surface-secondary',
      'color-on-primary',
      'color-surface-elevated',
      'color-on-secondary',
      'color-on-accent',
      'color-border',
      'color-outline',
      'color-overlay',
      'color-backplate',
      'color-scrim',
    ]

    const applyTheme = (theme) => {
      htmlElement.setAttribute('data-theme', theme)
      colorVariables.forEach((variable) => {
        const sourceVariable = `var(--${variable}-${theme})`
        htmlElement.style.setProperty(`--${variable}`, sourceVariable)
      })
      if (themeToggle) {
        themeToggle.setAttribute(
          'aria-pressed',
          theme === 'dark' ? 'true' : 'false'
        )
        themeToggle.setAttribute(
          'aria-label',
          theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'
        )
      }
      localStorage.setItem('korpus-theme', theme)
    }

    const initializeTheme = () => {
      const storedTheme = localStorage.getItem('korpus-theme')
      const systemPrefersDark = window.matchMedia(
        '(prefers-color-scheme: dark)'
      ).matches
      const currentTheme = storedTheme || (systemPrefersDark ? 'dark' : 'light')
      applyTheme(currentTheme)
    }

    const toggleTheme = () => {
      const currentTheme = htmlElement.getAttribute('data-theme') || 'light'
      const newTheme = currentTheme === 'light' ? 'dark' : 'light'
      applyTheme(newTheme)
    }

    if (themeToggle) {
      addListener(themeToggle, 'click', toggleTheme)
    }

    const systemThemeQuery = window.matchMedia('(prefers-color-scheme: dark)')
    const handleSystemThemeChange = (event) => {
      if (!localStorage.getItem('korpus-theme')) {
        applyTheme(event.matches ? 'dark' : 'light')
      }
    }
    if (systemThemeQuery?.addEventListener) {
      systemThemeQuery.addEventListener('change', handleSystemThemeChange)
      cleanupHandlers.push(() =>
        systemThemeQuery.removeEventListener('change', handleSystemThemeChange)
      )
    }

    initializeTheme()

    const mobileMenuToggle = document.getElementById('mobileMenuToggle')
    const navMenu = document.getElementById('navMenu')
    const navigationMain = document.getElementById('navigationMain')

    const setMenuOpenState = (isOpen) => {
      if (!mobileMenuToggle || !navMenu) {
        return
      }
      mobileMenuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false')
      navMenu.classList.toggle('nav-korpus__menu--open', isOpen)
      navMenu.classList.toggle('active', isOpen)
      document.body.style.overflow = isOpen ? 'hidden' : ''
    }

    const toggleMobileMenu = () => {
      const isExpanded = mobileMenuToggle?.getAttribute('aria-expanded') === 'true'
      setMenuOpenState(!isExpanded)
    }

    const closeMobileMenu = () => {
      setMenuOpenState(false)
    }

    const handleEscapeKey = (event) => {
      if (
        event.key === 'Escape' &&
        mobileMenuToggle?.getAttribute('aria-expanded') === 'true'
      ) {
        closeMobileMenu()
        mobileMenuToggle?.focus()
      }
    }

    addListener(mobileMenuToggle, 'click', toggleMobileMenu)
    addListener(document, 'keydown', handleEscapeKey)

    const menuLinks = navMenu?.querySelectorAll('.nav-korpus__link') || []
    menuLinks.forEach((link) => addListener(link, 'click', closeMobileMenu))

    let ticking = false
    const updateNavOnScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      if (navigationMain) {
        navigationMain.classList.toggle('nav-korpus--scrolled', scrollTop > 50)
      }
      ticking = false
    }

    const requestScrollUpdate = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateNavOnScroll)
        ticking = true
      }
    }

    addListener(window, 'scroll', requestScrollUpdate, { passive: true })

    let resizeTimer
    const handleResize = () => {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(() => {
        if (
          window.innerWidth > 991 &&
          mobileMenuToggle?.getAttribute('aria-expanded') === 'true'
        ) {
          closeMobileMenu()
        }
      }, 250)
    }
    addListener(window, 'resize', handleResize)

    this._cleanupNavigation = () => {
      cleanupHandlers.forEach((handler) => handler())
      cleanupHandlers.length = 0
      clearTimeout(resizeTimer)
    }
  },
  beforeUnmount() {
    if (this._cleanupNavigation) {
      this._cleanupNavigation()
    }
  },
}
</script>

<style>
[data-theme='dark'] .nav-korpus__theme-icon--sun {
  transform: translateY(-100%) rotate(-180deg);
  opacity: 0;
}
[data-theme='dark'] .nav-korpus__theme-icon--moon {
  transform: translateY(0) rotate(0deg);
  opacity: 1;
}
@media (max-width: 991px) {
  body:has(.nav-korpus__menu.nav-korpus__menu--open) .nav-korpus__mobile-cta {
    transform: translateY(0);
    opacity: 1;
    pointer-events: auto;
  }
}
@media (prefers-reduced-motion: reduce) {
  .nav-korpus,
  .nav-korpus__link::after,
  .nav-korpus__theme-toggle,
  .nav-korpus__theme-icon,
  .nav-korpus__mobile-toggle,
  .nav-korpus__mobile-icon,
  .nav-korpus__menu,
  .nav-korpus__mobile-cta {
    transition-duration: 0.01ms;
  }
}
#navMenu.active {
  opacity: 1;
  max-height: 100vh;
  transform: translateY(0);
  pointer-events: auto;
}
#navMenu.active ~ .nav-korpus__mobile-cta {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}
#mobileMenuToggle[aria-expanded='true'] .nav-korpusmobile-icon1 {
  opacity: 0;
  transform: rotate(90deg);
}
#mobileMenuToggle[aria-expanded='true'] .nav-korpusmobile-icon2 {
  opacity: 1;
  transform: rotate(0deg);
}
</style>

<style scoped>
.navigation-container10 {
  display: contents;
}
 
.navigation-container11 {
  display: none;
}
 
.navigation-container12 {
  display: contents;
}
 
.navigation-container13 {
  display: none;
}
 
.navigation-container14 {
  display: contents;
}
 
.navigation-container15 {
  display: none;
}
 
.navigation-container16 {
  display: contents;
}
 
.navigation-container17 {
  display: none;
}
 
.navigation-container18 {
  display: contents;
}
 
.navigation-container21 {
  text-decoration: none;
}
 
.navigation-container24 {
  text-decoration: none;
}
 
.navigation-container25 {
  text-decoration: none;
}
 
.navigation-container26 {
  text-decoration: none;
}
 
.navigation-container27 {
  display: none;
  text-decoration: none;
}
 
.navigation-container28 {
  text-decoration: none;
}
 
.navigation-thq-nav-korpusmenu-item-elm6 {
  display: none;
}
 
.navigation-container29 {
  text-decoration: none;
}
 
.navigation-container30 {
  text-decoration: none;
}
 
.navigation-thq-nav-korpustheme-icon1-elm {
  width: 100%;
  height: 100%;
  display: flex;
  opacity: 1;
  position: absolute;
  transform: translateY(0) rotate(0deg);
  transition: transform 0.4s var(--animation-curve-primary),
      opacity 0.4s var(--animation-curve-primary);
  align-items: center;
  justify-content: center;
}
 
.navigation-thq-nav-korpustheme-icon2-elm {
  width: 100%;
  height: 100%;
  display: flex;
  opacity: 0;
  position: absolute;
  transform: translateY(100%) rotate(180deg);
  transition: transform 0.4s var(--animation-curve-primary),
      opacity 0.4s var(--animation-curve-primary);
  align-items: center;
  justify-content: center;
}
 
.navigation-container31 {
  text-decoration: none;
}
 
.navigation-thq-nav-korpusmobile-icon1-elm {
  width: 100%;
  height: 100%;
  display: flex;
  opacity: 1;
  position: absolute;
  transform: rotate(0deg);
  transition: transform 0.3s var(--animation-curve-primary),
      opacity 0.3s var(--animation-curve-primary);
  align-items: center;
  justify-content: center;
}
 
.navigation-thq-nav-korpusmobile-icon2-elm {
  width: 100%;
  height: 100%;
  display: flex;
  opacity: 0;
  position: absolute;
  transform: rotate(90deg);
  transition: transform 0.3s var(--animation-curve-primary),
      opacity 0.3s var(--animation-curve-primary);
  align-items: center;
  justify-content: center;
}

.arrow {
  display: inline-block;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 6px solid #333;
  transition: transform 0.2s ease;
}

.arrow.open {
  transform: rotate(90deg); /* points down */
}

.language-selector {
  position: relative;
  cursor: pointer;
  margin-left: 20px;
  user-select: none;
}

.language-selector .current-language {
  font-weight: 500;
}

.language-selector .arrow {
  display: inline-block;
  margin-left: 6px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #333;
  transition: transform 0.2s ease;
}

.language-selector .arrow.open {
  transform: rotate(180deg);
}

.language-options {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #ccc;
  list-style: none;
  padding: 5px 0;
  margin: 0;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  z-index: 999;
}

.language-options li {
  padding: 8px 16px;
  cursor: pointer;
  white-space: nowrap;
}

.language-options li:hover {
  background-color: #f0f0f0;
}

</style>
